export default "__VITE_ASSET__kQ2TlKMn__"